import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class SimStore {
  sim = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      sim: observable,
      total: observable,
      loading: observable,
      loadData: action,
      addData: action,
      getSimData: action,
      SampleExcel: action,
      addSimNoByExcel: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit }) {
    this.loading = true;
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=sim&a=getDetails");

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/simList/getSimDetails");

    this.sim = response?.data?.data;
    this.loading = false;
  }

  async SampleExcel() {
    window.location.href = config.fleetURL + "/appRes/excel/Sim_Upload.xlsx";
  }

  async addData(values) {
    var postData = values;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=sim&a=update", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/simList/saveSimDetails", values);

    return response.data;
  }

  async getSimData(id) {
    var postData = { id: id, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=sim&a=getDetails", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/simList/getSimDetails", {
        params: postData,
      });
    return response?.data?.data[0];
  }

  async deleteRecord({ simId }) {
    var postData = { tokenId: "", simId: simId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=sim&a=delete", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/simList/deleteSim/${simId}`);
    return response;
  }

  // async addSimNoByExcel(excelFile) {
  //   this.excelLoadig = true;
  //   var postData = excelFile;

  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post("index.php?c=sim&a=simexcel", "postData=" + base64Input);
  //   this.excelLoadig = false;
  //   return response.data;
  // }

  async addSimNoByExcel(excelFile) {
    this.excelLoadig = true;
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/simList/importSimData", excelFile);
      this.excelLoadig = false;
      return response.data;
    } catch (error) {
      this.excelLoadig = false;
      return error?.response?.data;
    }
  }
}

export default SimStore;
